module.exports = __webpack_public_path__ + "img/jingjiren.fe9cc019.png";